module.exports = function(scope, defaultValues, values){
  for (var key in defaultValues){
    scope[key] = typeof values[key] !== 'undefined' ? values[key] : defaultValues[key];
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/sprite-anim/src/utils/default-values.js
// module id = 42
// module chunks = 0